import { safeToRem } from "@faire/slate/lib/sizeUnitUtils";

import {
  DEFAULT_SKELETON_IMAGE_SIZE,
  DEFAULT_SKELETON_AVATAR_DIAMETER,
  DEFAULT_SKELETON_TITLE_TEXT_WIDTH,
  DEFAULT_SKELETON_TITLE_TEXT_HEIGHT_REM,
  DEFAULT_SKELETON_PARAGRAPH_TEXT_WIDTH,
  DEFAULT_SKELETON_PARAGRAPH_TEXT_HEIGHT_REM,
} from "./const";
import { skeletonVars } from "./SkeletonBase";
import { SkeletonVariant } from "./type";

type IOptions = {
  width?: number;
  height?: number;
  diameter?: number;
  size?: number;
};

export const getSkeletonVars = (
  variant?: SkeletonVariant,
  options?: IOptions
) => {
  switch (variant) {
    case "square": {
      const size = options?.size ?? DEFAULT_SKELETON_IMAGE_SIZE;
      return skeletonVars({
        width: safeToRem(size),
        height: safeToRem(size),
      });
    }
    case "circle": {
      const size = options?.diameter ?? DEFAULT_SKELETON_AVATAR_DIAMETER;
      return skeletonVars({
        width: safeToRem(size),
        height: safeToRem(size),
        radius: safeToRem(size),
      });
    }
    case "titleText":
      return skeletonVars({
        width: safeToRem(options?.width ?? DEFAULT_SKELETON_TITLE_TEXT_WIDTH),
        height: DEFAULT_SKELETON_TITLE_TEXT_HEIGHT_REM,
      });
    case "paragraphText":
      return skeletonVars({
        width: safeToRem(
          options?.width ?? DEFAULT_SKELETON_PARAGRAPH_TEXT_WIDTH
        ),
        height: DEFAULT_SKELETON_PARAGRAPH_TEXT_HEIGHT_REM,
      });
    case "canvas":
    default:
      return skeletonVars({
        width: safeToRem(options?.width),
        height: safeToRem(options?.height),
      });
  }
};
